<div class="tooltip-content" [class.is-conflict]="isConflict()">
    <h4>{{isConflict() ? 'Conflicting' : 'Server'}} Change</h4>
    <div>
        Another user has made changes to this item.
        @if (isConflict()) { You can't save your changes. }
        Please synchronize with the server version.
    </div>
    <ul>
        <li><b>Changed by:</b> {{changedBy()}}</li>
        <li><b>Changed at:</b>  {{changedAt() | date: 'dd.MM.yyyy HH:mm'}}</li>
    </ul>
</div>
